import { linear } from "svelte/easing";

export function drawPath(node, { duration, easing, delay, offset }) {
  const startOffset = offset || 300;
  node.style.strokeDasharray = `${startOffset}px`;

  return {
    delay,
    duration,
    easing,
    css: t => {
      const newOffset = (1 - t) * startOffset;

      return `stroke-dashoffset: ${newOffset}px`;
    }
  };
}
